(function () {
  'use strict';

  if (customElements.get('product-stock-actions')) return;

  class ProductStockActions extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-stock-open]');
      this.closeButton = this.querySelector('[data-stock-close]');
      this.shareButton = this.querySelector('[data-stock-share]');
      this.shareStatus = this.querySelector('[data-stock-share-status]');
      this.overlay = this.querySelector('[data-stock-overlay]');
      this.panel = this.querySelector('[data-stock-panel]');
      this.tableBody = this.querySelector('[data-stock-table-body]');
      this.total = this.querySelector('[data-stock-total]');
      this.year = this.querySelector('[data-stock-year]');
      this.variantId = this.dataset.variantId;
      this.lastFocusedElement = null;

      if (this.year) this.year.textContent = String(new Date().getFullYear());

      this.onOpen = this.openPanel.bind(this);
      this.onClose = this.closePanel.bind(this);
      this.onShare = this.shareProduct.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);

      this.openButton?.addEventListener('click', this.onOpen);
      this.closeButton?.addEventListener('click', this.onClose);
      this.overlay?.addEventListener('click', this.onClose);
      this.shareButton?.addEventListener('click', this.onShare);
      document.addEventListener('keydown', this.onKeydown);

      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
        this.unsubscribeVariant = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
          const nextVariantId = event?.data?.variant?.id;
          if (nextVariantId) this.variantId = String(nextVariantId);
        });
      } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const nextVariantId = event?.data?.variant?.id;
          if (nextVariantId) this.variantId = String(nextVariantId);
        });
      }
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.onOpen);
      this.closeButton?.removeEventListener('click', this.onClose);
      this.overlay?.removeEventListener('click', this.onClose);
      this.shareButton?.removeEventListener('click', this.onShare);
      document.removeEventListener('keydown', this.onKeydown);
      if (typeof this.unsubscribeVariant === 'function') this.unsubscribeVariant();
    }

    getCurrentVariantId() {
      const productInfo = document.querySelector(`product-info[data-product-id="${CSS.escape(this.dataset.productId || '')}"]`);
      const variantInput = productInfo?.querySelector('form[action*="/cart/add"] input[name="id"]');
      return variantInput?.value || this.variantId || this.dataset.variantId;
    }

    openPanel() {
      if (!this.panel || !this.overlay) return;

      this.lastFocusedElement = document.activeElement;
      this.overlay.hidden = false;
      this.panel.classList.add('is-open');
      this.panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bit-stock-panel-open');
      this.closeButton?.focus();
      this.loadStock();
    }

    closePanel() {
      if (!this.panel || !this.overlay) return;

      this.panel.classList.remove('is-open');
      this.panel.setAttribute('aria-hidden', 'true');
      this.overlay.hidden = true;
      document.body.classList.remove('bit-stock-panel-open');
      this.lastFocusedElement?.focus?.();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.panel?.classList.contains('is-open')) this.closePanel();
    }

    setMessage(message) {
      if (!this.tableBody) return;
      this.tableBody.replaceChildren();
      const row = document.createElement('tr');
      const cell = document.createElement('td');
      cell.colSpan = 2;
      cell.textContent = message;
      row.appendChild(cell);
      this.tableBody.appendChild(row);
      if (this.total) this.total.textContent = '';
    }

    appendStockRow(warehouse, quantity, emphasize) {
      const row = document.createElement('tr');
      const warehouseCell = document.createElement('td');
      const quantityCell = document.createElement('td');

      if (emphasize) {
        const strong = document.createElement('strong');
        strong.textContent = warehouse;
        warehouseCell.appendChild(strong);
      } else {
        warehouseCell.textContent = warehouse;
      }

      quantityCell.textContent = String(quantity);
      row.append(warehouseCell, quantityCell);
      this.tableBody.appendChild(row);
    }

    createSummaryMetric(label, value) {
      const metric = document.createElement('span');
      metric.className = 'product-stock-actions__total-item';

      const labelElement = document.createElement('span');
      labelElement.className = 'product-stock-actions__total-label';
      labelElement.textContent = label;

      const valueElement = document.createElement('strong');
      valueElement.className = 'product-stock-actions__total-value';
      valueElement.textContent = value;

      metric.append(labelElement, valueElement);
      return metric;
    }

    renderStock(data) {
      const stockData = data?.stock_data;
      if (!data?.success || !stockData || typeof stockData !== 'object') {
        this.setMessage('No se pudo consultar las existencias.');
        return;
      }

      this.tableBody.replaceChildren();
      let total = 0;
      let rowCount = 0;

      Object.values(stockData).forEach((skuInfo) => {
        const warehouses = Array.isArray(skuInfo?.almacenes) ? skuInfo.almacenes : [];
        warehouses.forEach((warehouseObject) => {
          if (!warehouseObject || typeof warehouseObject !== 'object') return;

          Object.entries(warehouseObject).forEach(([warehouse, rawQuantity]) => {
            const normalizedWarehouse = warehouse.toLowerCase().trim();
            if (normalizedWarehouse === 'promocion') return;

            const numericQuantity = Number(rawQuantity);
            const quantity = Number.isFinite(numericQuantity) ? numericQuantity : 0;
            total += quantity;
            rowCount += 1;
            this.appendStockRow(
              warehouse,
              quantity,
              normalizedWarehouse === 'tlaxcala' || normalizedWarehouse === 'puebla'
            );
          });
        });
      });

      if (rowCount === 0) this.appendStockRow('N/A', 0, false);
      const inventorySync = data?.inventory_sync;
      const priceSync = data?.price_sync;
      if (this.total) {
        this.total.replaceChildren(
          this.createSummaryMetric('Total de existencias', String(total))
        );

        if (priceSync?.requested === true && priceSync.success === true) {
          const formattedPrice = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
          }).format(Number(priceSync.price));
          this.total.appendChild(this.createSummaryMetric('Precio actualizado', formattedPrice));
        } else if (priceSync?.skipped && priceSync.price !== null && priceSync.price !== undefined) {
          const formattedPrice = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
          }).format(Number(priceSync.price));
          this.total.appendChild(this.createSummaryMetric('Precio actual', formattedPrice));
        } else if (priceSync?.requested === true) {
          const priceStatus = document.createElement('span');
          priceStatus.className = 'product-stock-actions__total-status';
          priceStatus.textContent = priceSync.skipped ? 'Precio sin cambios' : 'Precio sin actualizar';
          this.total.appendChild(priceStatus);
        }

        if (inventorySync?.requested === true && inventorySync.success === false) {
          const inventoryStatus = document.createElement('span');
          inventoryStatus.className = 'product-stock-actions__total-status';
          inventoryStatus.textContent = 'Inventario sin actualizar';
          this.total.appendChild(inventoryStatus);
        }
      }
    }

    async loadStock() {
      const apiUrl = (this.dataset.apiUrl || '').trim();
      const variantId = this.getCurrentVariantId();

      if (!apiUrl) {
        this.setMessage('Configura la URL de existencias en la configuración del tema.');
        return;
      }
      if (!variantId) {
        this.setMessage('No se encontró la variante seleccionada.');
        return;
      }

      this.setMessage('Consultando existencias...');
      this.openButton?.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ variant_ids: [String(variantId)], sync_product: true })
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.renderStock(await response.json());
      } catch (error) {
        console.error('Error al consultar existencias:', error);
        this.setMessage('Ocurrió un error al consultar las existencias.');
      } finally {
        this.openButton?.removeAttribute('aria-busy');
      }
    }

    async shareProduct() {
      const shareData = { title: document.title, url: window.location.href };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          this.showShareStatus('Producto compartido');
          return;
        }

        await navigator.clipboard.writeText(shareData.url);
        this.showShareStatus('Enlace copiado');
      } catch (error) {
        if (error?.name !== 'AbortError') this.showShareStatus('No se pudo copiar el enlace');
      }
    }

    showShareStatus(message) {
      if (!this.shareStatus) return;
      this.shareStatus.textContent = message;
      window.clearTimeout(this.shareStatusTimer);
      this.shareStatusTimer = window.setTimeout(() => {
        this.shareStatus.textContent = '';
      }, 3000);
    }
  }

  customElements.define('product-stock-actions', ProductStockActions);
})();
